import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material'
import { OrganizationType } from '../../../../models/OrganizationType'

interface Props {
  value?: OrganizationType | null
  isdEemId?: number | null
  disabled?: boolean
  required?: boolean
  error?: boolean
  onChange?: (organizationType: OrganizationType, organizationId: number | null) => void
}
export const OrganizationTypeSelector = (props: Props): JSX.Element => {
  const handleOrganizationTypeUpdate = (value: string): void => {
    if (value === props.value) return

    switch (value) {
      case OrganizationType.Isd:
        props.onChange?.(OrganizationType.Isd, props.isdEemId ?? null)
        break
      case OrganizationType.District:
        props.onChange?.(OrganizationType.District, null)
        break
    }
  }

  return (
    <FormControl
      fullWidth
      data-testid='organizationType'
      disabled={props.disabled}
      required={props.required}
      error={props.error}
    >
      <RadioGroup
        row
        defaultValue={props.value}
        name='organizationType'
        onChange={(_, value) => { handleOrganizationTypeUpdate(value) }}
        value={props.value}
        sx={{ display: 'flex', gap: '8px' }}
      >
        <FormLabel sx={{ alignContent: 'center' }}>Is this for an {OrganizationType.Isd} or a {OrganizationType.District}?</FormLabel>
        <Box>
          {Object.values(OrganizationType).map((orgType) => (
            <FormControlLabel
              key={orgType}
              value={orgType ?? ''}
              label={orgType}
              control={<Radio />}
              data-testid={`organizationType${orgType}`}
            />
          ))}
        </Box>
      </RadioGroup>
    </FormControl>
  )
}
